import { useMemo, useCallback, useState } from 'react';

import { filterListWithQuery } from '@ts-core/utils/filters';

interface FilteredDataHookInput<TITem extends object> {
  items?: TITem[];
  fields: string[];
}

interface FilteredDataHookOutput<TITem extends object> {
  query?: string;
  onFilterData: (query: string) => void;

  filteredData: TITem[];
}

export default function useFilteredData<TItem extends object>(input: FilteredDataHookInput<TItem>): FilteredDataHookOutput<TItem> {
  const { items = [], fields } = input;
  const [query, setQuery] = useState<string>();

  const filteredData = useMemo(() => {
    return filterListWithQuery({
      list: items,
      query,
      fields,
    });
  }, [items, query, fields]);

  const onFilterData = useCallback((newQuery: string) => {
    setQuery(newQuery);
  }, []);

  return {
    query,
    onFilterData,
    filteredData,
  };
}
